// NuvenarHub CRM dual-fire for all Snatch & Glow contact forms.
// Intercepts submit on every .ecom__form (Ecomus theme contact + booking
// forms), POSTs a normalized payload to the n8n webhook in parallel with the
// native Shopify contact_form submit. Non-blocking: if n8n is unreachable,
// Shopify's native flow still runs (email to shop owner).
//
// Captures gclid + UTM params from the URL or sessionStorage so the
// offline-conversion uploader can attribute leads back to the right ad
// click in Google Ads. Added 2026-05-26.
(function () {
  var WEBHOOK = 'https://flow.usonatech.com/webhook/snatchglow-form';
  var STORAGE_PREFIX = 'sng_';
  var ATTRIB_KEYS = ['gclid','fbclid','utm_source','utm_medium','utm_campaign','utm_term','utm_content'];

  // ── Persist URL params to sessionStorage on every page load so they
  // survive navigation between landing → form page.
  try {
    var qp = new URLSearchParams(window.location.search);
    ATTRIB_KEYS.forEach(function (k) {
      var v = qp.get(k);
      if (v) sessionStorage.setItem(STORAGE_PREFIX + k, v);
    });
  } catch (_) {}

  // ── Identify which page-level form this is (for form_name attribution).
  function inferFormName(formEl) {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('free-consultation') !== -1) return 'snatchglow_free_consultation';
    if (path.indexOf('book-appointment')   !== -1) return 'snatchglow_book_appointment';
    if (path.indexOf('contact')            !== -1) return 'snatchglow_contact_us';
    var id = (formEl && formEl.id) || '';
    if (id) return 'snatchglow_form_' + id.replace(/[^a-z0-9_-]/gi, '_');
    return 'snatchglow_unknown_form';
  }

  // ── Build payload from form fields. Shopify's native contact form names
  // fields like contact[name], contact[email], contact[phone], contact[<custom>].
  function buildPayload(formEl) {
    var data = new FormData(formEl);
    function pick() {
      for (var i = 0; i < arguments.length; i++) {
        var v = data.get(arguments[i]);
        if (v !== null && String(v).trim() !== '') return String(v).trim();
      }
      return '';
    }
    var name = pick('contact[name]', 'contact[Name]', 'contact[full_name]', 'name');
    var nameParts = name.split(/\s+/).filter(Boolean);
    var fn = nameParts[0] || '';
    var ln = nameParts.slice(1).join(' ') || '';
    var email = pick('contact[email]', 'contact[Email]', 'email');
    var phone = pick(
      'contact[Contact No.]', 'contact[phone]', 'contact[Phone]',
      'contact[phone_number]', 'contact[Phone Number]', 'phone'
    );
    var treatment = pick(
      'contact[Select Treatment]', 'contact[Treatment]',
      'contact[treatment]', 'contact[service]', 'contact[Service]'
    );
    var dateTime = pick(
      'contact[Date & Time]', 'contact[date_time]',
      'contact[Date]', 'contact[Appointment Date]'
    );
    var message = pick(
      'contact[body]', 'contact[message]', 'contact[Message]',
      'contact[notes]', 'contact[Comments]'
    );

    var payload = {
      firstName: fn,
      lastName:  ln,
      email:     email,
      phone:     phone,
      treatment: treatment,
      message:   (message || '') + (dateTime ? ' [Preferred: ' + dateTime + ']' : ''),
      landing_page: window.location.href,
      referrer:     document.referrer || '',
      form_name:    inferFormName(formEl)
    };

    // Attach gclid + UTM from URL or sessionStorage.
    try {
      var qp2 = new URLSearchParams(window.location.search);
      ATTRIB_KEYS.forEach(function (k) {
        var v = qp2.get(k) || sessionStorage.getItem(STORAGE_PREFIX + k) || '';
        if (v) payload[k] = v;
      });
    } catch (_) {}

    return payload;
  }

  function fireToN8n(formEl) {
    try {
      var payload = buildPayload(formEl);
      if (!payload.email && !payload.phone) return; // nothing to attribute
      fetch(WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'no-cors'
      }).catch(function () {});
    } catch (_) {}
  }

  // ── Attach a single capture-phase listener so it runs even if the form
  // has its own submit handler that calls preventDefault.
  document.addEventListener('submit', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (!t.classList.contains('ecom-contact-form') && !t.classList.contains('ecom__form')) return;
    fireToN8n(t);
    // Do NOT preventDefault — let Shopify's native /contact handler run.
  }, true);
})();
